import { Dispatch } from 'redux';
import store from '~/data/store';
import { listRequest } from '~/data/store/reducer/onCallRequest/actions/list';

import { iActionList } from '~/domain/interfaces/redux/onCallRequest/list';

import { ListOnCallRequest } from '~/domain/usecases/onCallRequest/redux';

export class ReduxListOnCallRequest implements ListOnCallRequest {
  private send: Dispatch;

  constructor() {
    this.send = store.dispatch;
  }

  list = (params: ListOnCallRequest.Params): iActionList =>
    this.send(listRequest(params));
}
